import { render, staticRenderFns } from "./PermissionTemplateList.vue?vue&type=template&id=670968f4&"
import script from "./PermissionTemplateList.vue?vue&type=script&lang=js&"
export * from "./PermissionTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTemplateList.vue?vue&type=style&index=0&id=670968f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports